module.exports = __webpack_public_path__ + "img/AD.ac1c4dc1.svg";